export default __webpack_public_path__ + "static/media/download.9ae3dc1f.svg";